<div class="footer-container">
  <div class="copyright">
    <span> &copy; {{copyrightStartYear}}-{{year}} {{copyrightOrganisation}} |
      <a href="{{ termsConditions }}" target="_blank">{{'term_condition' | translate}}</a> </span>
  </div>
</div>
